var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditsCardDefaultLtr = function SvgCreditsCardDefaultLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M88.755 21h-77.51C7.804 21 5 23.83 5 27.302v45.396C5 76.17 7.804 79 11.245 79h77.51C92.196 79 95 76.17 95 72.698V27.302C95 23.83 92.196 21 88.755 21m.892 12.002v-5.7c0-.49-.407-.9-.892-.9h-77.51a.907.907 0 0 0-.892.9v5.843zM10.353 41l79.294-.142v31.841c0 .49-.407.9-.892.9h-77.51a.907.907 0 0 1-.892-.9z",
    clipRule: "evenodd"
  })));
};
export default SvgCreditsCardDefaultLtr;